import React from "react";
import Sidenav from "./Sidenav";
import { Box, Chip, Avatar, useMediaQuery } from "@mui/material";
import Navbar from "./Navbar";
import Grid from "@mui/material/Grid";
import { Card, CardContent, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import Menu from "@mui/material/Menu";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import MenuIcon from "@mui/icons-material/ArrowDropDown";
import Paper from "@mui/material/Paper";
import "../../assets/css/styles.css";
import WordIcon from "../../assets/images/word.png"; // Import your Word icon PNG
import ExcelIcon from "../../assets/images/excel.png"; // Import your Excel icon PNG
import PdfIcon from "../../assets/images/pdf3.png";
import TablePagination from "@mui/material/TablePagination";
import FolderIcon from "../../assets/images/folder3.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import CustomSnackbar from "../shared/snackbar";
import Checkbox from "@mui/material/Checkbox";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import pngIcon from "../../assets/images/png2.png";
import zipIcon from "../../assets/images/zip1.png";
import DefaultIcon from "../../assets/images/default.png";
import mp4Icon from "../../assets/images/mp4.png";
import TextIcon from "../../assets/images/default.png";
import jpgIcon from "../../assets/images/jpg.png";
import jsonIcon from "../../assets/images/json.png";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import "../../assets/css/styles.css";
// import Avatar from '@mui/material/Avatar';

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const imageStyle = {
  maxWidth: "32px", // Set a maximum width for the image
  maxHeight: "32px", // Set a maximum height for the image
};
const fileIconMapping = {
  pdf: <img src={PdfIcon} alt="Word" style={imageStyle} />, // Example: PDF files
  doc: <img src={WordIcon} alt="Word" style={imageStyle} />, // Example: Word documents
  docx: <img src={WordIcon} alt="Word" style={imageStyle} />, // Example: Word documents
  jpg: <img src={jpgIcon} alt="Word" style={imageStyle} />, // Example: JPEG images
  jpeg: <img src={pngIcon} alt="Word" style={imageStyle} />, // Example: JPEG images
  png: <img src={pngIcon} alt="Word" style={imageStyle} />, // Example: PNG images
  mp4: <img src={mp4Icon} alt="Word" style={imageStyle} />, // Example: MP4 videos
  txt: <img src={TextIcon} alt="Word" style={imageStyle} />,
  xlsx: <img src={ExcelIcon} alt="Word" style={imageStyle} />,
  zip: <img src={zipIcon} alt="Word" style={imageStyle} />,
  folders: <img src={FolderIcon} alt="Word" style={imageStyle} />,
  json: <img src={jsonIcon} alt="Word" style={imageStyle} />,
  // Add more file extensions and icons as needed
  default: <img src={FolderIcon} alt="Word" style={imageStyle} />,
};
const Favorites = ({ size, url }) => {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const LIST_FAVORITES = `${SERVER_URI}/favorites/list`;
  const REMOVE_FAVORITES = `${SERVER_URI}/favorites/remove`;
  const ADD_FAVORITES = `${SERVER_URI}/favorites/add`;

  const [selectedFilter, setSelectedFilter] = React.useState("all");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [message, setMessage] = React.useState("");
  const [variant, setMessageVariant] = React.useState("");
  const [snackbaropen, setSnackbarOpen] = React.useState(false);
  const [anchorEle, setAnchorEle] = React.useState(null);

  const handleMenuClose = (filter) => {
    setAnchorEle(null);
    if (filter) {
      handleFilterChange(filter);
    }
  };
  const handleMenuClick = (event) => {
    setAnchorEle(event.currentTarget);
  };

  const getLabelWithIcon = () => {
    // Return label with corresponding icon based on selectedFilter
    switch (selectedFilter) {
      case "folder":
        return {
          label: "Folders",
          icon: <Avatar alt="Folder" src={FolderIcon} />,
        };
      case "word":
        return { label: "Word", icon: <Avatar alt="Word" src={WordIcon} /> };
      case "pdf":
        return { label: "PDF", icon: <Avatar alt="PDF" src={PdfIcon} /> };
      case "excel":
        return { label: "Excel", icon: <Avatar alt="Excel" src={ExcelIcon} /> };
      default:
        return { label: "All", icon: <MenuIcon /> };
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    // You can implement filtering logic here based on the selected filter.
  };

  // Get access to the history object

  const handleGoBack = () => {
    // Navigate to the previous page
    window.history.back();
  };

  // Function to add a file to favorites
  const addFileToFavorites = async (filename, url, size) => {
    try {
      const token = localStorage.getItem("accessToken");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const response = await axios.post(
        ADD_FAVORITES,
        { fileName: filename, filePath: url, size: size },
        config
      );
      console.log("Filename:", filename);
      console.log("URL:", url);
      console.log("size:", size);

      // Handle the response
      setSnackbarOpen(true);
      setMessage(response.data.message); // Assuming the message is in the response data
      setMessageVariant("success");
    } catch (error) {
      console.error("Failed to add file to favorites:", error);
      setSnackbarOpen(true);
      setMessage("Failed to add file to favorites");
      setMessageVariant("error");
      // Handle the error (e.g., show an error message)
    }

    setTimeout(() => {
      setSnackbarOpen(false);
    }, 2000);
  };

  React.useEffect((size) => {
    // Fetch the favorite files when the component mounts
    const fetchFavoriteFiles = async (size, url) => {
      try {
        let token = localStorage.getItem("accessToken");
        let config = {
          headers: { Authorization: `Bearer ${token}` },
        };
        const response = await axios.get(LIST_FAVORITES, config, size, url);

        if (response.data && response.data.files) {
          // Use response instead of responseData
          const fileData = response.data.files.map((file) => {
            console.log("API Data:", file);

            // Formatting the modifiedDate
            const modifiedDate = new Date(file.modifiedDate);
            const formattedDate = `${modifiedDate.getDate()}-${
              monthNames[modifiedDate.getMonth()]
            }-${modifiedDate.getFullYear()}`;

            return {
              filename: file.fileName,
              modifiedDate: formattedDate,
              url: url,
              size: file.size,
              // url: file.url,
            };
          });

          setFavoriteFiles(fileData);
          setSnackbarOpen(true);
          setMessage("Favorite files retrieved");
          setMessageVariant("success");
          setTimeout(() => {
            setSnackbarOpen(false);
          }, 2000);
        } else {
          console.error("Failed to fetch data from the API");
        }
      } catch (error) {
        console.error("Error while fetching favorite files:", error);
        setSnackbarOpen(true);
        setMessage("Failed to retrieve favorite files");
        setMessageVariant("error");
        setTimeout(() => {
          setSnackbarOpen(false);
        }, 2000);
      }
    };

    fetchFavoriteFiles();
  }, []);

  // Function to remove a file from favorites
  const removeFileFromFavorites = async (filename, url) => {
    try {
      let token = localStorage.getItem("accessToken");
      let config = {
        headers: { Authorization: `Bearer ${token}` },
        data: { fileName: filename, filePath: url },
      };
      const response = await axios.delete(REMOVE_FAVORITES, config);
      setSnackbarOpen(true);
      setMessage(response.data.message);
      setMessageVariant("success");
    } catch (error) {
      console.error("Failed to remove file from favorites:", error);
      setSnackbarOpen(true);
      setMessage(error.response.data.message);
      setMessageVariant("error");
      // Handle the error (e.g., show an error message)
    }
    setTimeout(() => {
      setSnackbarOpen(false);
    }, 2000);
  };

  const getFileExtension = (filename) => {
    // Check if filename is defined and not null
    if (filename) {
      const parts = filename.split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "default";
      return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
    }
    // Return a default extension or handle the case where filename is undefined or null
    return "unknown";
  };

  const [favoriteFiles, setFavoriteFiles] = React.useState([]);
  // Function to list favorite files

  const [filteredFiles, setFilteredFiles] = React.useState([]);

  React.useEffect(() => {
    // Filter the files based on the selected filter
    console.log(
      "Effect executed with selectedFilter:",
      selectedFilter,
      "and rows:",
      filteredFiles
    );
    const filtered = favoriteFiles.filter((file) => {
      if (selectedFilter === "all") return true;
      if (selectedFilter === "folders") return !file.filename.includes("."); // Files without an extension
      if (selectedFilter === "word") return /\.(doc|docx)$/.test(file.filename); // Files with .doc or .docx extension
      if (selectedFilter === "pdf") return file.filename.endsWith(".pdf"); // Files with .pdf extension
      if (selectedFilter === "excel") return file.filename.endsWith(".xlsx"); // Files with .xl extension
    });

    setFilteredFiles(filtered);
  }, [selectedFilter, favoriteFiles]);

  const [hoveredRow, setHoveredRow] = React.useState(null);

  const handleRowMouseEnter = (fileId) => {
    setHoveredRow(fileId);
  };

  const handleRowMouseLeave = () => {
    setHoveredRow(null);
  };
  const handleFavoritesToggle = async (filename, url) => {
    if (favoriteFiles.some((file) => file.filename === filename)) {
      await removeFileFromFavorites(filename, url);
      setFavoriteFiles((prevFiles) =>
        prevFiles.filter((file) => file.filename !== filename)
      );
    } else {
      // addFileToFavorites(filename, url, size);
    }
  };
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const handleRowSelect = (event, fileName) => {
    const checked = event.target.checked;

    if (checked) {
      // Add the filename to the selectedFiles array
      setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, fileName]);
    } else {
      // Remove the filename from the selectedFiles array
      setSelectedFiles((prevSelectedFiles) =>
        prevSelectedFiles.filter((file) => file !== fileName)
      );
    }
  };
  const isTablet = useMediaQuery("(max-width: 900px)"); // Tablet screen detection
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <Box>
      <div className="bgcolor">
        <Navbar />

        <Box height={70} />

        <Box sx={{ display: "flex", padding: "1%" }}>
          <Sidenav />

          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: "80%",
              position: "relative",
              right: { xs: "2%", sm: "6%", md: "2%" },

            }}
          >
            <IconButton
              onClick={handleGoBack}
              color="primary"
              sx={{ marginLeft: "6%" }}
            >
              <ArrowBackIcon />
              <Typography>{/* <strong>Back</strong> */}</Typography>
            </IconButton>
            <Grid container spacing={2}>
              <Grid
                item
                xs={8}
                sm={12}
                sx={{
                  marginBottom: "2%",
                  position: "relative",
                  left: "6%",
                  top: { xs: "0%", sm: "10%", md: "10%" },
                  width: { xs: "80%", sm: "80%", md: "100%" },
                }}
              >
                <Typography
                  gutterBottom
                  variant="body2"
                  component="div"
                  sx={{
                    color: "black",
                    fontSize: "20px",
                    // marginTop: "50px",
                    marginLeft: "11px",
                    marginBottom: "20px",
                  }}
                >
                  <strong>Favorites</strong>
                </Typography>
                {!isMobile && (
                  <Stack spacing={2} direction="row" width="89%">
                    {/* "All" Chip will always show label */}
                    <Chip
                      label="All"
                      variant={selectedFilter === "all" ? "filled" : "outlined"}
                      onClick={() => handleFilterChange("all")}
                      sx={{
                        width: "150px",
                        height: "40px",
                        border: "2px solid grey",
                        "&:hover": {
                          border: "2px solid black",
                        },
                      }}
                    />
                    {/* "Folders" Chip */}
                    <Chip
                      label={!isTablet ? "Folders" : null} // No label on tablet
                      variant={
                        selectedFilter === "folder" ? "filled" : "outlined"
                      }
                      onClick={() => handleFilterChange("folder")}
                      icon={<Avatar alt="Folder" src={FolderIcon} />}
                      sx={{
                        width: "150px",
                        height: "40px",
                        border: "2px solid grey",
                        "&:hover": {
                          border: "2px solid black",
                        },
                      }}
                    />
                    {/* "Word" Chip */}
                    <Chip
                      label={!isTablet ? "Word" : null} // No label on tablet
                      variant={
                        selectedFilter === "word" ? "filled" : "outlined"
                      }
                      onClick={() => handleFilterChange("word")}
                      icon={<Avatar alt="Word" src={WordIcon} />}
                      sx={{
                        width: "150px",
                        height: "40px",
                        border: "2px solid grey",
                        "&:hover": {
                          border: "2px solid black",
                        },
                      }}
                    />
                    {/* "PDF" Chip */}
                    <Chip
                      label={!isTablet ? "PDF" : null} // No label on tablet
                      variant={selectedFilter === "pdf" ? "filled" : "outlined"}
                      onClick={() => handleFilterChange("pdf")}
                      icon={<Avatar alt="PDF" src={PdfIcon} />}
                      sx={{
                        width: "150px",
                        height: "40px",
                        border: "2px solid grey",
                        "&:hover": {
                          border: "2px solid black",
                        },
                      }}
                    />
                    {/* "Excel" Chip */}
                    <Chip
                      label={!isTablet ? "Excel" : null} // No label on tablet
                      variant={
                        selectedFilter === "excel" ? "filled" : "outlined"
                      }
                      onClick={() => handleFilterChange("excel")}
                      icon={<Avatar alt="Excel" src={ExcelIcon} />}
                      sx={{
                        width: "150px",
                        height: "40px",
                        border: "2px solid grey",
                        "&:hover": {
                          border: "2px solid black",
                        },
                      }}
                    />
                  </Stack>
                )}

                {/* For mobile screens, show only the "All" chip with a dropdown */}
                {isMobile && (
                  <Stack spacing={2} direction="row">
                    <Chip
                      label={getLabelWithIcon().label} // Dynamic label based on selected filter
                      variant="outlined"
                      icon={<MenuIcon />}
                      onClick={handleMenuClick}
                      sx={{
                        width: "150px",
                        height: "40px",
                        border: "2px solid grey",
                        "&:hover": {
                          border: "2px solid black",
                        },
                      }}
                    />
                    <Menu
                      anchorEl={anchorEle}
                      open={Boolean(anchorEle)}
                      onClose={() => handleMenuClose(null)}
                    >
                      <MenuItem onClick={() => handleMenuClose("all")}>
                        All
                      </MenuItem>
                      <MenuItem onClick={() => handleMenuClose("folder")}>
                        <Avatar alt="Folder" src={FolderIcon} /> Folders
                      </MenuItem>
                      <MenuItem onClick={() => handleMenuClose("word")}>
                        <Avatar alt="Word" src={WordIcon} /> Word
                      </MenuItem>
                      <MenuItem onClick={() => handleMenuClose("pdf")}>
                        <Avatar alt="PDF" src={PdfIcon} /> PDF
                      </MenuItem>
                      <MenuItem onClick={() => handleMenuClose("excel")}>
                        <Avatar alt="Excel" src={ExcelIcon} /> Excel
                      </MenuItem>
                    </Menu>
                  </Stack>
                )}
              </Grid>

              <Grid item xs={12}>
                <Paper
                  sx={{
                    overflow: "auto",
                    maxHeight: "100vh",
                    borderRadius: "20px",
                    width: { xs: "100%", sm: "100%", md: "90%" },
                    marginTop: {
                      xs: "0px",
                      // sm: "30px",
                      // md: "0px",
                      // lg: "30px",
                    },
                    position: "relative",
                    left: "6%",
                  }}
                >
                  {" "}
                  {/* Add borderRadius here */}
                  {/* ... your existing code ... */}
                  <TableContainer
                    sx={{
                      maxHeight: 440,
                      borderRadius: "20px",
                      overflow: "hidden",
                    }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" style={{ minWidth: "100px" }}>
                            <Checkbox />
                            <strong>Name</strong>
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              minWidth: "100px",
                              display: { xs: "none", sm: "table-cell" },
                            }}
                          >
                            <strong>Last Modified</strong>
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              minWidth: "100px",
                              display: { xs: "none", sm: "table-cell" },
                            }}
                          >
                            <strong>File Size</strong>
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ minWidth: "100px" }}
                          ></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredFiles
                          .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                          .map((file) => {
                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={file.fileName}
                                onMouseEnter={() =>
                                  handleRowMouseEnter(file.filename)
                                }
                                onMouseLeave={handleRowMouseLeave}
                              >
                                {/* Adjust the column IDs and values based on your API response */}
                                <TableCell
                                  align="left"
                                  style={{ padding: "8px" }}
                                >
                                  <Checkbox
                                    checked={selectedFiles.includes(
                                      file.filename
                                    )}
                                    onChange={(event) =>
                                      handleRowSelect(event, file.filename)
                                    }
                                  />
                                  {fileIconMapping[
                                    getFileExtension(file.filename)
                                  ] || <InsertDriveFileIcon />}
                                  {/* <Avatar alt="File Icon" src={getIconForFileType(file.filename)} /> */}
                                  {file.filename}

                                  {hoveredRow === file.filename && (
                                    <div
                                      style={{
                                        position: "relative",
                                        bottom: "20px",
                                        marginLeft: "80px",
                                      }}
                                    >
                                      <IconButton
                                        style={{
                                          position: "absolute",
                                          top: "45%",
                                          left: "80%",
                                          transform: "translate(-50%, -50%)",
                                        }}
                                        onClick={() =>
                                          handleFavoritesToggle(
                                            file.filename,
                                            file.url,
                                            file.size
                                          )
                                        }
                                      >
                                        {/* {favoriteFiles.includes(file.filename) ? <StarBorderIcon /> : <StarIcon />  } */}
                                        {favoriteFiles.some(
                                          (file) =>
                                            file.filename === file.filename
                                        ) ? (
                                          <StarIcon />
                                        ) : (
                                          <StarBorderIcon />
                                        )}

                                        {/* <StarIcon color={favoriteFiles.includes(file.filename) ? 'success' : 'white'} /> */}
                                      </IconButton>
                                    </div>
                                  )}
                                </TableCell>
                                <TableCell>{file.modifiedDate}</TableCell>
                                {/* <TableCell></TableCell> */}
                                <TableCell>{file.size}</TableCell>
                                <TableCell></TableCell>
                                {/* <TableCell>{row.filePath}</TableCell> */}
                                {/* Add more columns as needed */}
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    className="tablepagenition"
                    rowsPerPageOptions={[5, 10, 100]}
                    component="div"
                    count={filteredFiles.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Stack spacing={2}></Stack>
            </Grid>

            {/* Add more content for the "Favorites" screen */}
          </Box>
        </Box>
        <CustomSnackbar
          message={message}
          variant={variant}
          open={snackbaropen}
        />
      </div>
    </Box>
  );
};

export default Favorites;
